import "./radar.css";

const Radar = () => {
  return (
    <div className="radar">
      <div className="scanner"></div>
      <img src="https://miro.medium.com/fit/c/262/262/2*5PeCflEgIe8WxPp3S6Vsiw.png" className="target" alt="institute-icons"></img>
      <img src="https://miro.medium.com/fit/c/262/262/2*5PeCflEgIe8WxPp3S6Vsiw.png" className="target" alt="institute-icons"></img>
      <img src="https://miro.medium.com/fit/c/262/262/2*5PeCflEgIe8WxPp3S6Vsiw.png" className="target" alt="institute-icons"></img>
      <img src="https://miro.medium.com/fit/c/262/262/2*5PeCflEgIe8WxPp3S6Vsiw.png" className="target" alt="institute-icons"></img>
	  </div>
  )
}

export default Radar;